import React from 'react';

const StripeContext = React.createContext({
  isReady: false,
  stripePromise: null,
});

export default StripeContext;
